import React from 'react';

import LinkButton from 'src/components/facilities/link-button';
import { MAIN_CONTENT_ID } from 'src/components/layout/page-layout-constants';
import { ButtonStyle } from 'src/enums/button-style';
import { useStaticTextTranslator } from 'src/translators/static-text-translator';

import * as styles from './a11y-skip-to-content.module.scss';

export const A11ySkipToContent: React.FC = () => {
  const translate = useStaticTextTranslator();

  const handleClick = () => {
    const target = document.getElementById(MAIN_CONTENT_ID);
    if (target) {
      target.focus();
    }
  };

  return (
    <LinkButton
      buttonLink={`#${MAIN_CONTENT_ID}`}
      buttonText={translate('skipToContent')}
      buttonStyle={ButtonStyle.PRIMARY}
      buttonType="button-header"
      className={styles.skipLink}
      handleClick={handleClick}
      isRedesignButton
    />
  );
};
